import { NetzbetreiberDatenabfrage } from './netzbetreiber-datenabfrage';

export class Aufteilungsschluessel {

    public aggregierteEndverbraucherlast: number;
    public aggregierteInstallierteKonventionelleErzeugerleistung: number;
    public aggregierteInstallierteEEGErzeugerleistung: number;
    public eegKwkgErzeugerleistungAbregelbarerAnteil: number;
    public westnetzNetzbetreiberDatenabfrageRto: NetzbetreiberDatenabfrage;
    public submitted: Date;
}
